import { render } from "./DynamicsTab.vue?vue&type=template&id=d6f61e8c&scoped=true"
import script from "./DynamicsTab.vue?vue&type=script&lang=js"
export * from "./DynamicsTab.vue?vue&type=script&lang=js"

import "./DynamicsTab.vue?vue&type=style&index=0&id=d6f61e8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6f61e8c"]])

export default __exports__